<card-container>
  <card title="Tài khoản" *ngIf="isOwner"
        description="Quản lý tài khoản truy cập vào hệ thống"
        icon="fa fa-key text-danger"
        routerLink="/configs/users"></card>

  <card title="Đối tác" *ngIf="isAdmin"
        description="Quản lý danh sách đối tác"
        icon="fa fa-user-tie text-primary"
        routerLink="/configs/partners"></card>

  <card title="Dịch vụ" *ngIf="isOwner"
        description="Quản lý danh sách dịch vụ"
        icon="fa fa-person-dolly text-warning"
        routerLink="/configs/services"></card>

  <card title="Sản phẩm" *ngIf="isAdmin"
        description="Quản lý danh sách sản phẩm"
        icon="fa fa-boxes text-success"
        routerLink="/configs/products"></card>

  <card title="Tùy chỉnh" *ngIf="isOwner"
        description="Các tùy chỉnh hệ thống"
        icon="fa fa-cog text-danger"
        routerLink="/configs/settings"></card>
</card-container>
